import {IInsideOrbitMenuActionInterface} from "../interface/inside-orbit-menu-action.interface";
import {IInsideOrbitMenuServices} from "../../../../services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {RESET_CONFIG} from "../../inside-orbit-menu-consts/inside-orbit-menu-text.consts";
import {CGP_CLIENT_KEY} from "../../inside-orbit-menu-consts/inside-orbit-menu-services.consts";



export class ResetConfigurationsAction implements IInsideOrbitMenuActionInterface {
    constructor(private services: IInsideOrbitMenuServices) {
    }

    get text() {
        return RESET_CONFIG;
    }

    execute = () => {
        this.services.storage.removeItem(CGP_CLIENT_KEY);
        this.services.location.redirect(this.services.location.currentUri.origin);
    }
}